export default {
  SET_CALENDAR_OPTIONS (state, val) {
    state.calendarOptions = val
  },
  SET_SELECTED_CALENDARS (state, val) {
    state.selectedCalendars = val
  },
}